import {FreeSpinsBasicState, FreeSpinsModule} from '@gongxigames/framework/slot';

export class GameFreeSpinsBasicState extends FreeSpinsBasicState {
    protected onFreeSpinsRestored(): void {
        this.module.soundPlayer.playMusic('freespin');
        this.module.gotoState(FreeSpinsModule.IN_PROGRESS_STATE);
    }
}
